import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import { StoneBrowser } from "../components/StoneBrowser";
import { Shapes } from "../components/Shapes";
import { WhatMatters } from "../components/WhatMatters";
import { scrollToId } from "../components/SmoothScroll";
import { usePageMeta } from "../lib/usePageMeta";

export default function Browse() {
  const [sp] = useSearchParams();
  const [shape, setShape] = useState(sp.get("shape") || "");
  usePageMeta(
    "Browse Lab Grown Diamonds by Shape, Sieve mm & Clarity | Round, Oval, Emerald, Princess – Padmavati",
    "Filter lab grown diamonds carat-wise by shape (round brilliant, oval, emerald, princess, cushion, pear, marquise, radiant, asscher, heart), sieve size in mm (-2 to +15) and clarity from FL to I3. Diamond sieve size chart and clarity scale explained."
  );
  return (
    <main data-testid="browse-page" className="pt-[72px]">
      <StoneBrowser externalShape={shape} />
      <Shapes number="02" onPick={(s) => { setShape(s); scrollToId("browse"); }} />
      <WhatMatters />
    </main>
  );
}
